import QuestionOptionsService from "@/services/QuestionsService";

export default {
    state() {
        return {
            questionOption: {
                text: "",
                image: "",
                correctAnswer: "",
                quizId: ""
            },
            questionOptionData: "",
            typeQuestionToManage: null,
            disciplineIdRelated: null,
            amountQuestionsToRender: 1,
            notValidQuestionsData: {
                questionIndex: null,
                alternativesIndex: []
            },
            questionToUpdate: null,
            errorsInQuestionImportation: [],
            errorBeingEditedIndex: null,
            questionsImported: 0,
            userValidatedFiles: false,
            userIsEditingErrorQuestion: false,
            questionImageToRender: null
        }
    },

    getters: {
        getImageToRender: (state) => state.questionImageToRender,
        getUserIsEditingErrorQuestion: (state) => state.userIsEditingErrorQuestion,
        getUserValidatedFiles: (state) => state.userValidatedFiles,
        getQuestionsImported: (state) => state.questionsImported ,
        getErrorsInQuestionImportation: (state) => state.errorsInQuestionImportation,
        getQuestionToUpdate: (state) => state.questionToUpdate,
        getNotValidAlternatives: (state) => state.notValidQuestionsData.alternativesIndex,
        getNotValidQuestionIndex: (state) => state.notValidQuestionsData.questionIndex,
        getQuestionType: (state) => state.typeQuestionToManage,
        getQuestionsAmount: (state) => state.amountQuestionsToRender,
        getDisciplineRelatedToQuizzes: (state) => state.disciplineIdRelated || null
    },

    mutations: {
        setQuestionImageToRender(state, data) {
            state.questionImageToRender = data || null
        },

        resetDataRelatedToImportation(state) {
            state.userIsEditingErrorQuestion = false
            state.userValidatedFiles = false
            state.questionsImported = 0
            state.errorBeingEditedIndex = null
            state.errorsInQuestionImportation = []
        },

        removeQuestionError(state) {
            state.errorsInQuestionImportation.splice(state.errorBeingEditedIndex, 1)
            state.questionsImported++
        },

        setUserIsEditingErrorQuestion(state, data) {
            state.userIsEditingErrorQuestion = data !== null && data !== undefined
            state.errorBeingEditedIndex = data
        },

        setUserValidatedFiles(state, data) {
          state.userValidatedFiles = data || false
        },

        setQuestionsImported(state, data) {
            state.questionsImported = data
        },

        setErrorsInQuestionImportation(state, data) {
            state.errorsInQuestionImportation = data || []
        },

        resetQuestionOptionsData(state) {
            state.questionToUpdate = null
            state.amountQuestionsToRender = 1
            state.disciplineIdRelated = null
            state.typeQuestionToManage = null
        },

        setQuestionToUpdateData(state, data) {
            if (data) {
                state.disciplineIdRelated = data.discipline_id || null
                state.typeQuestionToManage = data.type || null
                state.questionToUpdate = data || null
                state.amountQuestionsToRender = 1
            }
        },

        setNotValidAlternatives(state, data) {
          state.notValidQuestionsData.alternativesIndex = data || []
        },

        setNotValidQuestionIndex(state, data) {
            state.notValidQuestionsData.questionIndex = data
        },

        updateAmountQuestions(state, data) {
            data && (state.amountQuestionsToRender = data)
        },

        setQuestionsCreationData(state, data) {
            state.typeQuestionToManage = data?.typeQuestionToManage || null
            state.disciplineIdRelated = data?.disciplineIdRelated || null
            state.amountQuestionsToRender = data?.amountQuestionsToCreate || 1
        },

        setQuestionOptionData(state, data) {
            state.questionOption.text = data.text;
            state.questionOption.image = data.image;
            state.questionOption.correctAnswer = data.correct_answer;
            state.questionOption.quizId = data.quiz_id;
        },
        resetQuestionOption(state) {
            state.questionOption = {
                text: "",
                image:  "",
                correctAnswer: "",
                quizId: "",
            };
        },
        setQuestionOptionsData(state, data) {
            state.questionOptionData = data
        },
    },

    actions: {
        setQuestionImageToRender({commit}, payload) {
            commit('setQuestionImageToRender', payload)
        },

        resetDataRelatedToImportation({commit}) {
            commit('resetDataRelatedToImportation')
        },

        removeQuestionError({commit} , payload) {
            commit('removeQuestionError', payload)
        },

        setUserIsEditingErrorQuestion({commit}, payload) {
            commit('setUserIsEditingErrorQuestion', payload)
        },

        setUserValidatedFiles({commit}, payload) {
            commit('setUserValidatedFiles', payload)
        },

        setQuestionsImported({commit}, payload) {
            commit('setQuestionsImported', payload)
        },

        setErrorsInQuestionImportation({commit}, payload) {
            commit('setErrorsInQuestionImportation', payload)
        },

        resetQuestionOptionsData({commit}) {
          commit('resetQuestionOptionsData')
        },

        setQuestionToUpdateData({commit}, payload) {
            commit('setQuestionToUpdateData', payload)
        },

        setNotValidAlternatives({commit}, payload) {
            commit('setNotValidAlternatives', payload)
        },

        setNotValidQuestionIndex({commit}, payload) {
            commit('setNotValidQuestionIndex', payload)
        },

        updateAmountQuestions({commit}, payload) {
            commit('updateAmountQuestions', payload)
        },

        setQuestionsCreationData({commit}, payload) {
            commit('setQuestionsCreationData', payload)
        },

        async findQuestionOption({ commit }, payload) {
            try {
                const response = await QuestionOptionsService.findQuestionOption(payload.questionOptionId, payload.userToken);

                commit('setQuestionOptionData', response.data);

                return response.data;
            } catch (error) {
                console.error('Erro ao consultar alternativa:', error);

                throw new Error('Não foi possível consultar alternativa. Por favor, tente novamente.');
            }
        },

        async createManyQuestions({commit, dispatch, state}, payload) {
            try {
                dispatch('setLoadingState', {loadignState: true, loadingView: 'Questions Management'})
                const response = await QuestionOptionsService.createManyQuestions(payload)
                dispatch('incrementQuizzesCreatedWithOldData', response.data)
                state.userIsEditingErrorQuestion && (dispatch('removeQuestionError'))
                return response.data
            } catch (error) {
                dispatch('toastfy/activeErrorNotification', { text: error })
            } finally {
                dispatch('setLoadingState', {loadignState: false})
            }
        },

        async importQuestionsByFile({commit, dispatch}, payload) {
            try {
                dispatch("toastfy/activeSuccesNotification", { text: "Inicializando Validação de Arquivos!" })
                dispatch('setLoadingState', {loadignState: true, loadingView: 'Questions Management'})
                const response = await QuestionOptionsService.importQuestionsByFile(payload)
                await dispatch('setErrorsInQuestionImportation', response.errors)
                await dispatch('setQuestionsImported', response.quizzes.length)
                await dispatch('setUserValidatedFiles', true)
                if (response.quizzes.length > 0) {
                    await dispatch('createManyQuestions', {
                        requestData: {
                            discipline_id: payload.requestData.disciplineId,
                            quizzes: response.quizzes
                        },
                        useJsonContent: true,
                        userToken: payload.userToken
                    })
                    dispatch("toastfy/activeSuccesNotification", { text: "Questões Válidas estão sendo registradas!" })
                }

                if (response.errors.length > 0) {
                    dispatch('toastfy/activeErrorNotification', {text: "Algumas questões precisam de ajustes. Por favor, revise-as individualmente"})
                }

                return response
            } catch (error) {
                dispatch('toastfy/activeErrorNotification', { text: "Ocorreu um erro ao importar questões! Tente novamente" })
            } finally {
                dispatch('setLoadingState', {loadignState: false})
            }
        },

        async updateQuestion({commit, dispatch }, payload) {
            try {
                dispatch('setLoadingState', {loadignState: true, loadingView: 'Questions Management'})
                const response = await QuestionOptionsService.updateQuestion(payload)
                return response
            } catch (error) {
                dispatch('toastfy/activeErrorNotification', { text: error })
            } finally {
                dispatch('setLoadingState', {loadignState: false})
            }
        },

        async updateQuestionByAI({commit, dispatch}, payload) {
            try {
                dispatch('setLoadingState', {loadignState: true, loadingView: "Questions View"})
                dispatch('toastfy/activeSuccesNotification', { text: "Inicializando Correção! Aguarde" })
                return await QuestionOptionsService.updateQuestionByAI(payload)
            } catch (error) {
                dispatch('toastfy/activeErrorNotification', { text: error })
            } finally {
                dispatch('setLoadingState', {loadignState: false})
            }
        }
    }
}